import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export const feedbackService = {
  /**
   * Upload a screenshot for feedback
   * @param {Blob} screenshotBlob - Screenshot image blob
   * @returns {Promise} API response with S3 key and URL
   */
  uploadScreenshot: async (screenshotBlob) => {
    const formData = new FormData();
    formData.append('file', screenshotBlob, 'screenshot.png');

    return api.post('/feedback/upload-screenshot', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  /**
   * Submit user feedback
   * @param {Object} feedbackData - Feedback data
   * @param {string} feedbackData.feedback_text - The feedback message
   * @param {string} feedbackData.page_url - Current page URL
   * @param {string} feedbackData.user_agent - Browser user agent
   * @param {string} feedbackData.screenshot_s3_key - Optional S3 key for screenshot
   * @param {string} feedbackData.priority - Priority level
   * @param {string} feedbackData.category - Category/type
   * @returns {Promise} API response
   */
  submitFeedback: async (feedbackData) => {
    return api.post('/feedback', feedbackData);
  },

  /**
   * Update feedback status, priority, or category
   * @param {string} feedbackId - UUID of the feedback
   * @param {Object} updates - Fields to update
   * @returns {Promise} API response
   */
  updateFeedback: async (feedbackId, updates) => {
    return api.patch(`/feedback/${feedbackId}`, updates);
  },

  /**
   * Add a comment to feedback
   * @param {string} feedbackId - UUID of the feedback
   * @param {string} commentText - Comment message
   * @returns {Promise} API response
   */
  addComment: async (feedbackId, commentText) => {
    return api.post(`/feedback/${feedbackId}/comments`, { comment_text: commentText });
  },

  /**
   * Get all feedback submissions (admin only)
   * @param {number} limit - Number of results to return
   * @param {number} offset - Offset for pagination
   * @returns {Promise} API response with feedback list
   */
  getAllFeedback: async (limit = 100, offset = 0) => {
    return api.get('/feedback', { params: { limit, offset } });
  },

  /**
   * Get specific feedback by ID
   * @param {string} feedbackId - UUID of the feedback
   * @returns {Promise} API response with feedback details
   */
  getFeedbackById: async (feedbackId) => {
    return api.get(`/feedback/${feedbackId}`);
  }
};

export default feedbackService;